module.exports = __webpack_public_path__ + "4618534d6c20e6b4620c04ccf4323371.png";